import { TIMEZONE_TO_COUNTRY_CODE_MAP } from 'bl/validation/validatePhone.bl';

export const getIntlTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getIntlCountryCode = () => {
  const timeZone = getIntlTimeZone();
  return TIMEZONE_TO_COUNTRY_CODE_MAP[timeZone] || 'GB';
};
